import Head from "next/head";
import styles from "../tnpsc-group-i-prelims-test/tnpsc-group-i-prelims-test.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(() => import("../../components/might-be-interest"));
//import Banner from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-Gr1-Web-Banner.jpg";
//import MobBanner from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-GrI-Mobile-Banner.jpg";
import Link from "next/link";

const Tnpsc_Group_One_Prelims_Test_series = () => {
    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>TNPSC Group I Prelims Test Series Scale Up 2024 - Shankar IAS Academy</title>
                <meta name="title" content="TNPSC Group I Prelims Test Series Scale Up 2024 - Shankar IAS Academy" />
                <meta name="description" content="We are conducting TNPSC Group Ⅰ Prelims Test for TNPSC - Practice for TNPSC Prelims Revision and taking mock tests in an Exam - Shankar IAS Academy" />
                <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-I-scale-up/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="TNPSC Group I Prelims Test Series Scale Up 2024 - Shankar IAS Academy" />
                <meta property="og:description" content="We are conducting TNPSC Group Ⅰ Prelims Test for TNPSC - Practice for TNPSC Prelims Revision and taking mock tests in an Exam - Shankar IAS Academy" />
                <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-I-scale-up/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="tnpsc" />

            <div className="container">

                <div className="row">
                    <div className="col">
                    <h1 className={`${styles.sectiontitle}`} style={{color:"#db1b0d"}}>TNPSC Group I Prelims Test Series Scale Up 2024</h1>
                </div>
                </div>
                <div className="row d-none d-md-block">
                    
                </div>

                <div className="row d-block d-md-none">
                    
                </div>
            </div>


            {/* table */}

            <div className="container d-none d-lg-block">
                <div className="row pt-3 prelimstable">
                
                    <div className="col">
                        <div className={`${styles.tablescroll}`}>
                            <table class="table">
                                <thead class="table" style={{ backgroundColor: "#818C98" }}>
                                    <tr>
                                        <td className={`${styles.tableheading}`}>Center<br /></td>
                                        <td className={`${styles.tableheading}`}>Mode<br /></td>
                                        <td className={`${styles.tableheading}`}>Starts on<br /></td>
                                        <td className={`${styles.tableheading}`}>Fee<br /></td>
                                        <td className={`${styles.tableheading}`}>Schedule<br /></td>
                                        <td className={`${styles.tableheading}`}>Payment<br /></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch VII Regular(Offline/Online)<br /></td>
                                        <td className={`${styles.tablepara}`}>22th April 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Offline Students)</p></td>
                                        <td><Link href="/pdf/TNPSC-group-I-scale-up/Scale Up Batch7.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>New Delhi<br /></td>
                                        <td className={`${styles.tablepara}`}>Batch I Regular(Offline)<br /></td>
                                        <td className={`${styles.tablepara}`}>30th April 2024</td>
                                        <td className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /><p className={`${styles.tablepara}`}>₹4500 (For Old - Offline Students)</p></td>
                                        <td><Link href="/pdf/TNPSC-group-I-scale-up/Scale-Up-Batch-Delhi.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                        <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* mobile view table*/}
            <div className="container d-lg-none">
           
                <div className="">
                    <hr />
                    <p className={`${styles.mbtableheading} `}>Chennai - Anna Nagar<br /></p>
                    <p className={`${styles.tablepara}`}>Batch VII Regular (Offline/Online)</p>
                    <p className={`${styles.tablepara}`}>22th April 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /> ₹4500 (For Old - Offline Students)</p>
                    <div><Link href="/pdf/TNPSC-group-I-scale-up/Scale Up Batch7.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                    <br />
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                   
                </div>

                <div className="">
                    <hr />
                    <p className={`${styles.mbtableheading} `}>New Delhi<br /></p>
                    <p className={`${styles.tablepara}`}>Batch I Regular(Offline)</p>
                    <p className={`${styles.tablepara}`}>30th April 2024</p>
                    <p className={`${styles.tablepara}`}>₹5000 (For new students & Online Student)<br /> ₹4500 (For Old - Offline Students)</p>
                    <div><Link href="/pdf/TNPSC-group-I-scale-up/Scale-Up-Batch-Delhi.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                    <br />
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                    <hr />
                </div>
                  
                
            </div>
            <Interest />
            <Footer />
        </>
    )
}
export default Tnpsc_Group_One_Prelims_Test_series;
